/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Manual/VerifyAndSaveComponent" />
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import * as Resources from "DistributedTaskUI/ServiceEndpoints/Editor/Resources";
import React = require("react");
import { SplitButton } from "VSSUI/SplitButton";

interface IVerifyAndSaveComponentProps {
    disabled: boolean;
    handleSaveClick: () => void;
    handleVerifyAndSave: () => void;
}

export class VerifyAndSaveComponent extends VssComponent<IVerifyAndSaveComponentProps> {

    constructor(props: IVerifyAndSaveComponentProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): JSX.Element {

        const buttonProps = {
            text: Resources.VerifyAndSaveText,
            onClick: this.props.handleVerifyAndSave
        };
        const menuItems = [
            {
                id: "save",
                text: Resources.SaveText,
                onActivate: this.props.handleSaveClick
            },
        ];
        const menuButtonProps = {
            contextualMenuProps: {
                menuProps: {
                    id: "1",
                    items: menuItems
                }
            }
        };

        return (
            <SplitButton
                disabled={this.props.disabled}
                primary={true}
                buttonProps={buttonProps}
                menuButtonProps={menuButtonProps} />
        );

    }
}
